<script lang="ts">
  import { checkboxLabels } from "../lang";
  import type { FormOption } from "../types";

  export let items: FormOption<unknown>[];
  export let group: FormOption<unknown>["value"][];

  const allID = crypto.randomUUID();
  let allChecked = false;
  let allIndeterminate = false;

  function onAllChange(event) {
    const { checked } = event.target as HTMLInputElement;

    if (checked) {
      group = items.map((item) => item.value);
    } else {
      group = [];
    }
  }

  function onChange() {
    allChecked = group.length === items.length;
    allIndeterminate = group.length !== 0 && !allChecked;
  }
</script>

<div class="CheckboxGroup">
  <div class="CheckboxGroup-field">
    <input
      class="CheckboxGroup-input"
      type="checkbox"
      id={allID}
      bind:checked={allChecked}
      bind:indeterminate={allIndeterminate}
      on:change={onAllChange}
    />
    <label class="CheckboxGroup-label CheckboxGroup-label--all" for={allID}>
      {checkboxLabels.selectAll}
    </label>
  </div>

  <hr />

  <div class="CheckboxGroup-group">
    {#each items as { label, value }}
      {@const id = crypto.randomUUID()}

      <div class="CheckboxGroup-field">
        <input
          class="CheckboxGroup-input"
          type="checkbox"
          bind:group
          {id}
          {value}
          on:change={onChange}
        />
        <label class="CheckboxGroup-label" for={id}>{label}</label>
      </div>
    {/each}
  </div>
</div>

<style>
  .CheckboxGroup-group {
    display: grid;
    gap: var(--size-20);
    grid-template-columns: var(--columns);
  }

  .CheckboxGroup-field {
    align-items: center;
    display: flex;
    gap: var(--size-8);
  }

  .CheckboxGroup-input {
    block-size: var(--size-16);
    inline-size: var(--size-16);
  }

  .CheckboxGroup-label {
    font-size: var(--size-13);
  }

  .CheckboxGroup-label--all {
    font-weight: 600;
  }
</style>
